import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const SmsLine16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4 11.75H9.88223L9.51612 12.1161L8 13.6322L6.48388 12.1161L6.11777 11.75H5.6H2.4C1.76487 11.75 1.25 11.2351 1.25 10.6V3.4C1.25 2.76487 1.76487 2.25 2.4 2.25H13.6C14.2351 2.25 14.75 2.76487 14.75 3.4V10.6C14.75 11.2351 14.2351 11.75 13.6 11.75H10.4ZM7.43431 14.8343L5.6 13H2.4C1.07452 13 0 11.9255 0 10.6V3.4C0 2.07452 1.07452 1 2.4 1H13.6C14.9255 1 16 2.07452 16 3.4V10.6C16 11.9255 14.9255 13 13.6 13H10.4L8.56569 14.8343C8.25327 15.1467 7.74673 15.1467 7.43431 14.8343ZM4 8.2C4.66274 8.2 5.2 7.66274 5.2 7C5.2 6.33726 4.66274 5.8 4 5.8C3.33726 5.8 2.8 6.33726 2.8 7C2.8 7.66274 3.33726 8.2 4 8.2ZM8 8.2C8.66274 8.2 9.2 7.66274 9.2 7C9.2 6.33726 8.66274 5.8 8 5.8C7.33726 5.8 6.8 6.33726 6.8 7C6.8 7.66274 7.33726 8.2 8 8.2ZM12 8.2C12.6627 8.2 13.2 7.66274 13.2 7C13.2 6.33726 12.6627 5.8 12 5.8C11.3373 5.8 10.8 6.33726 10.8 7C10.8 7.66274 11.3373 8.2 12 8.2Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
